import { Maybe } from 'ballerina-core'
import { Img, ImgProps } from '../img'
import React from 'react'

type PageheaderImageProps = {
  image: Maybe<Pick<ImgProps, 'alt' | 'src' | 'crops'>>
  isHome: boolean
}

export const PageheaderImage = ({ image, isHome }: PageheaderImageProps) => {
  if (!image) return null

  return (
    <div className="ph__visual">
      <div className='ph__media fit-object'>
        <Img
          {...image}
          width={isHome ? '1020' : '888'}
          height={isHome ? '782' : '888'}
          sizes={isHome ? '(min-width: 1280px) 1020px, (min-width: 1024px) 85vw, 130vw' : '(min-width: 1280px) 888px, (min-width: 1024px) 75vw, (min-width: 768px) 672px, 90vw'}
          className="ph__image"
          loading="eager"
        />
      </div>
    </div>
  )
}
